export const CountNotification = ({ totalCount }: { totalCount?: number }) => {
  if (!totalCount) return null;

  return (
    <span className="flex items-center justify-center size-4 font-bold rounded bg-alpha-100 text-xxs text-content-1000">
      {totalCount}
    </span>
  );
};
